import "./cover-img-container.comp.scss";
// import upIco from "../../assets/icons/arrow-up.svg";
import { HomeMainCompProps } from "../home-main-comp/home-main.comp";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
// import SkillChart from "../charts/skill.chart";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import angularIco from "../../assets/icons/angular.svg";
import reactIco from "../../assets/icons/react.svg";

const CoverImgContainer = ({ homeMainCompData }: HomeMainCompProps) => {
  const d = homeMainCompData;
  const subtitles = d.subtitle.split("<split/>");
  const text = d.text?.split("<split/>");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    location.hash &&
      document
        .querySelector(location.hash)
        ?.scrollIntoView({ behavior: "smooth" });
  }, [location.hash]);

  return (
    <article
      className={`cover-img-container ${d.label}-section`}
      id={`${d.label}-section`}
    >
      <div className="cover-content">
        {location.pathname === "/about-me" && d.label !== "profile" && (
          <div className="back-btn" onClick={onGoToUp}>
            <ArrowCircleUpIcon />
          </div>
        )}

        <div className="text-container">
          <div className="cover-header-container">
            <div className="title-container">
              <p className="subtitle">
                {subtitles[0]}
                {subtitles.length > 1 && (
                  <span className="first-name">{subtitles[1]}</span>
                )}
              </p>
              <h3 className="title">{d.title}</h3>
            </div>

            {/*location.pathname === "/skills" && (
              <div className="chart-dev-skills-container">
                <SkillChart label={d.label}></SkillChart>
              </div>
            )*/}
          </div>

          <div className="children-container">
            <p contentEditable="false">
              {text && text[0]} {/* HOME */}
              {text && text.length > 1 && location.pathname === "/about-me" && (
                <>
                  <b>{text[1]}</b>
                  {text[2]}
                </>
              )}
              {/* SKILLS */}
              {text && text.length > 1 && location.pathname === "/skills" && (
                <>
                  <b>
                    {text[1]} <img src={angularIco} alt="" />
                  </b>
                  {text[2]}
                  <b>
                    {text[3]} <img src={reactIco} alt="" />
                  </b>
                </>
              )}
            </p>

            <aside className="children">{d.children}</aside>

            <div className="action-container">
              {d.button.map((b) => (
                <button
                  onClick={() => onClickCoverButton(b.value, navigate)}
                  key={b.label + b.value}
                >
                  {b.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mask"></div>

      <div className="img-container">
        <div className="mask"></div>
        <img src={d.img} alt={`cover picture ${d.label}`} />
      </div>
    </article>
  );
};

export default CoverImgContainer;

const onClickCoverButton = (
  target: "more-ig" | "more-dev" | "as-ig" | "as-dev",
  navigate: NavigateFunction
) => {
  switch (target) {
    case "as-dev": {
      document
        .querySelector("#developer-section")
        ?.scrollIntoView({ behavior: "smooth" });
      break;
    }
    case "as-ig": {
      document
        .querySelector("#graphic-designer-section")
        ?.scrollIntoView({ behavior: "smooth" });
      break;
    }
    case "more-dev": {
      navigate("/skills#developer-section", { replace: true });
      break;
    }
    case "more-ig": {
      navigate("/skills#graphic-designer-section", { replace: true });
      break;
    }
  }
};

function onGoToUp() {
  document
    .getElementById("profile-section")
    ?.scrollIntoView({ behavior: "smooth" });
}
